import { IUserDto } from 'typings/user';
import { User } from 'nomst/Stores/User/user';

export class UserFactory {
    static getUser(user: IUserDto): User {
        return new User(
            user.userId,
            user.displayName,
            user.employeeSourceId,
            user.roles,
            user.isHrAssistant);
    }
}